import React from "react";
import { ShareButton } from "../../atoms/form/button/share";
import styled from "styled-components";
import { SiTiktok } from "react-icons/si";
import { Flex } from "rebass/styled-components";
import { openWebShare, trackClipSocialShare } from "./utils";

const StyledBackground = styled(Flex)`
  position: relative;
  padding: 8px;
  background: #0f100f;
  border-radius: 50%;
`;

const StyledShare = styled(SiTiktok)`
  position: relative;
  color: #f7fcfd;
`;

export default function TiktokShare({ file, clip, ...props }) {
  return (
    <>
      <ShareButton
        justifyContent="center"
        alignItems="center"
        target="_blank"
        onClick={async () => {
          try {
            openWebShare({ file, clip });
            trackClipSocialShare({
              platform: "App Share",
              clip,
            });
          } catch (e) {}
        }}
        {...props}
      >
        <Flex alignItems="center">
          <StyledBackground>
            <StyledShare size={16}></StyledShare>
          </StyledBackground>
          <Flex alignItems="flex-start" flexDirection="column"></Flex>
          {props.children}
        </Flex>
      </ShareButton>
    </>
  );
}
